import React from 'react'
import MobileDetect from 'mobile-detect'
import debounce from 'lodash.debounce'
import Footer from '../components/footer'
import MobileMenu from '../components/mobile-menu'


const windowPresent = (typeof window !== 'undefined')
const md = windowPresent
  ? new MobileDetect(window.navigator.userAgent)
  : {mobile: () => { return false }}
const isMobile = md.mobile()

export default class MobileContent extends React.Component {
 constructor() {
   super()

   this.state = {
     windowWidth: windowPresent ? window.innerWidth : 1920,
   }
 }

 componentDidMount() {
   this.setState({ windowWidth: windowPresent ? window.innerWidth : 1920 })
   windowPresent && window.addEventListener("resize", this.updateDimensions)
 }

 componentWillUnmount() {
   windowPresent && window.removeEventListener("resize", this.updateDimensions)
 }

 updateDimensions = debounce(() => {
   this.setState({ windowWidth: windowPresent ? window.innerWidth : 1920, windowHeight: windowPresent ? window.innerHeight : 1920})
 }, 40)

render(){
   return (
     <div>
       {!isMobile && this.state.windowWidth > 737
       ? <Footer />
       : <MobileMenu />}
    </div>
   )
  }
}



// WEBPACK FOOTER //
// ./src/components/mobile-content.js